// extracted by mini-css-extract-plugin
export var desktopOnly = "utils-module--desktopOnly--gvak1";
export var mobileOnly = "utils-module--mobileOnly--6Qjb6";
export var pageMinHeight = "utils-module--pageMinHeight--mg+OQ";